import { render, staticRenderFns } from "./KemajuanMahasiswaMagister.vue?vue&type=template&id=00e121b6"
import script from "./KemajuanMahasiswaMagister.vue?vue&type=script&lang=js"
export * from "./KemajuanMahasiswaMagister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports